export class BaseEntity {
}
